module.exports = __webpack_public_path__ + "img/shi-logo-big.89dcef47.png";